import React from 'react'
import moment from 'moment/moment'
import { Link } from 'react-router-dom'
import { Tag } from 'antd'
import classNames from 'classnames'

function ListMexRow(props) {
    const { item, setType } = props
    const { name, created_at, product_types, status, mex, partner, sewing_partner, brand, statistic } = item
    const Partner = !!partner && !!partner.name ? partner.name : '-'
    const sewingPartner = !!sewing_partner && !!sewing_partner.name ? sewing_partner.name : '-'
    const userMex = !!mex && !!mex.user ? mex.user : '-'
    const mexDate = !!mex && !!mex.started_at ? moment(mex.started_at).format('HH:mm DD/MM/YYYY') : '-'
    const quantity = !!statistic && (!!statistic.mex || statistic.mex === 0) ? statistic.mex : '-'

    const _generateLevel = (level) => {
        const color = level === 'highest' ? 'rgb(255 45 0)' : level === 'high' ? '#FFD300' : ''
        return <Tag className={classNames(`tag-${level}`)}
            color={color}>{level !== undefined ? level : 'medium'}</Tag>
    }

    const color = classNames({
        'pending progress-bar-animated progress-bar-striped': status === 'pending' || status === 'processing',
        'printing progress-bar-animated progress-bar-striped': status === 'printing',
        'printed': status === 'printed',
        'transferring progress-bar-animated progress-bar-striped': status === 'transferring',
        'transferred': status === 'transferred',
        'confirmed': status === 'confirmed',
        'wait-sew progress-bar-animated progress-bar-striped': status === 'wait_to_sew',
        'sewing': status === 'sewing',
        'completed': status === 'completed' || status === 'done',
    })

    const onClickType = (value) => {
        setType(value)
    }

    return (
        <tr>
            <td className='nameLo'>
                <Link to={`/batches/${item._id}`} className='w-100'>
                    {name}
                </Link>
                {
                    _generateLevel(item.level)
                }
            </td>
            <td>{moment(created_at).format('HH:mm DD/MM/YYYY') || '-'}</td>
            <td className="ProductType">
                {!!product_types && product_types.length > 0 && product_types.map((type, index) => {
                    return type !== null &&
                        <span key={index} className="mr-2" onClick={() => onClickType([type])}>{type}</span>
                })
                }
                {!!brand &&
                    <div className="Brand">
                        <span className="mr-2" >{brand}</span>
                    </div>
                }
            </td>
            <td className="text-center Status">
                <span className={`badge ${color} badge-pill`}>{status}</span>
            </td>
            <td>{quantity}</td>
            <td>{userMex}</td>
            <td>{Partner}</td>
            <td>{sewingPartner}</td>
            <td>{mexDate}</td>
        </tr>
    )
}

export default ListMexRow